import React from "react"
import {connect} from "react-redux";
import moment from "moment"
import {cloneDeep, max, orderBy} from "lodash"
import { Spin, Skeleton, Divider } from "antd";
import MediaQuery from "react-responsive";
import CardDetailsCarousel from "./component/CardDetailsCarousel"
import CardInfoPanel from "./component/CardInfoPanel"
import AllCardsView from "./component/AllCardsView"
import {
  dateFormat,
  commaSeparator,
  getStoredDates,
  getDateRanges,
  getDateQuery,
  getSelectedDate,
  getCardsListByYearWise,
  CREDIT_SCORE_700,
  CREDIT_SCORE_600_700,
  CREDIT_SCORE_STARTER,
  CURRENT_YEAR,
  CURRENT_MONTH_LONG,
  FILTER_CARDS,
  COSTS_BENCHMARK,
} from "../../../../../utils/constants";
import DotImage from "../../../../../assets/images/dashboard/dot.svg"
import DotFill from "../../../../../assets/images/dashboard/dot-fill.svg"
import {Loading} from '../../../../../common/components/Loading/Loading';
import { setCards, fetchCards } from "../../../../../redux/modules/cards/cardsActions";
import {setResultSetting} from "../../../../../redux/modules/resultSetting/resultSettingActions";
import EnableCardsChart from "./component/EnableCardsChart";
import CardsFilter from "./component/CardsFilter";
import SettingModal from "./component/SettingModal";
import RewardCalculationModal from "./component/RewardCalculationModal";
import RecommendedCards from "./component/RecommendedCards"
import CardDetailsModal from "./component/CardDetailsModal"
import YearProjection from "./component/YearProjection"
import TopSpending from "./component/TopSpending";
import FilterSettings from "./component/FilterSettings";
import "./datePicker.scss";
import {Tooltip} from "antd";
import Help from "../../../../../assets/images/dashboard/help-icon.svg";
import {Link} from "react-router-dom";



class SecondStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isRunTested: false,
      isSettingModal: false,
      isCalculationModal: false,
      isYearChanging: false,
      isCardDetailsModal: false,
      activeTab: "all",
      selectedDate: 1,
      selectedCard: 0,
      selectedCardInfo: {},
      selectedRange: [moment(new Date(new Date().setFullYear(new Date().getFullYear() - 1))), moment()],
      enableCardLength: 0,
      selectedFeatures: [],
      selectedCategories: []
    }
  }
  
  componentDidMount() {
    const { cardList, fetchCardsLoaded, fetchCardsLoading, isAccountsLoading, isManualCost } = this.props
    if(!((cardList || []).length && fetchCardsLoaded) && !fetchCardsLoading && !isAccountsLoading && !isManualCost) {
      this.onGetCardsList()
    }
    if(Object.keys(getStoredDates() || {}).length) {
      const { dateType, date } = getStoredDates() || {}
      this.setState({
        selectedDate: Number(dateType) || 1,
        selectedRange: (date || []).length && Number(dateType) === 6 ? [moment(date[0]), moment(date[1])] : this.state.selectedRange
      })
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.isCardRequest) {
      this.props.onCardRequestChange(false)
      this.onGetCardsList()
    } else if(nextProps.resettingCard) {
      this.onCardChange(0)
    }
  }

  onGetCardsList = async () => {
    const { getEnableCardsIds, onFetchCards, onSetCards, onPlaidModalChange } = this.props

    const ids = getEnableCardsIds()

    await onFetchCards({
      apiEndpoint: "plaid/auth/run-backtest",
      query: `?${ids.join("&")}${getDateQuery()}`,
      onSuccess: (res) => {
        onSetCards(res || {})
        this.setState({
          isRunTested: false
        })
        localStorage.setItem("LUCI_DATAS", JSON.stringify(this.props.state))
      },
      onFail: (response) => {
        if (response?.data?.errors && response.data.errors[0]?.param?.error_type === 'popup') {
          onPlaidModalChange({
            isPlaidPopUp: true,
            institutionName: response.data.errors[0]?.param?.institutionName,
            currentStep: 0,
            plaidPopUpErrorMsg: response.data.errors[0]?.msg || ""
          });
        }
        this.setState({
          isRunTested: false
        })
        localStorage.setItem("LUCI_DATAS", JSON.stringify(this.props.state))
      }
    });
  }

  onTabChange = (value) => {
    this.setState({
      activeTab: value,
      selectedCard: 0
    })
  }
  
  onDateChange = (value) => {
    const selectedRange = getDateRanges(value)
    this.setState({
      selectedDate: value,
      selectedRange
    });
  }
  
  onCardChange = (value) => {
    this.setState({
      selectedCard: value
    })
  }
  
  onSelectCard = (info) => {
    const { isCardDetailsModal } = this.state
    this.setState({
      isCardDetailsModal: !isCardDetailsModal,
      selectedCardInfo: isCardDetailsModal ? {} : info
    })
  }
  
  onRangeDatesChange = (selectedRanges) => {
    this.setState({
      selectedRange: selectedRanges
    });
  }

  getSelectedDate = () => {
    const { isManualCost } = this.props;
    const { selectedRange, selectedDate } = this.state;
    if(isManualCost) {
      return "12 Months"
    } else if(selectedDate === 6) {
      const date1 = ((selectedRange && selectedRange[0] && selectedRange[0].clone()) || (selectedRange && selectedRange[1] && selectedRange[1].clone()) || moment()).format(dateFormat);
      const date2 = ((selectedRange && selectedRange[1] && selectedRange[1].clone()) || (selectedRange && selectedRange[0] && selectedRange[0].clone()) || moment()).format(dateFormat);
      return `${date1} - ${date2}`;
    } else {
      return getSelectedDate(selectedDate)
    }
  }
  
  getCardsList = () => {
    const { selectedCategories, selectedFeatures } = this.state
    
    let list = cloneDeep(this.props.cardList)
    
    /*if (activeTab !== "all") {
      list = list.filter(x => {
        return (x.card.category || []).filter(y => {
          return [(activeTab || "").toLowerCase()].some(element => (y || "").toLowerCase().includes(element))
        }).length > 0;
      });
    }*/

    list = orderBy(list, ["totalMoney", 'cardName'], "desc");

    if((selectedCategories || []).length || (selectedFeatures || []).length) {
      return FILTER_CARDS(list, selectedCategories, selectedFeatures);
    } else {
      return list;
    }
  }
  
  getTotalRewards = () => {
      const value = (this.getCardsList() || []).length && this.getCardsList()[0].totalMoney || 0
      return ((value) || 0).toFixed(2) || '0.00';
  }

  onFilterChange = (type, value) => {
    let list = this.state[type]
    if((list || []).includes(value)) {
      list = (list || []).filter(x => x !== value)
    } else {
      list.push(value)
    }
    this.setState({
      [type]: list,
      selectedCard: 0
    })
  }

  onDismissFilter = () => {
    this.setState({
      selectedFeatures: [],
      selectedCategories: [],
      selectedCard: 0
    })
  }

  onModalChange = () => {
    this.setState({
      isSettingModal: !this.state.isSettingModal
    })
  }

  onApplyingSetting = () => {
    this.props.onCardRequestChange(true)
    this.onModalChange()
    this.onCardChange(0)
  }

  onGetSelectedDate = () => {
    const { selectedDate } = this.state
    if(selectedDate === 1) {
      return "12 Months"
    } else if(selectedDate === 2) {
      return "6 Months"
    } else if(selectedDate === 3) {
      return "3 Months"
    } else if(selectedDate === 4) {
      return "1 Month"
    } else if(selectedDate === 5) {
      return "Max (12 Months)"
    } else if(selectedDate === 6) {
      return this.getSelectedDate()
    } else if(selectedDate === 7) {
      return "9 Months"
    }
  }

  getSelectedCard = () => {
    const { getEnableCardsIds, banks } = this.props
    const length = (getEnableCardsIds() || []).length

    let text = ""
    if(length === 1) {
      banks.forEach(bank => {
        bank.accounts.forEach(account => {
          if(account.enabled) {
            text = (account.official_name || account.name)
          }
        })
      })
    } else {
      text = `${length} of your cards.`
    }

    return text
  }

  onCalculationModalChange = () => {
    this.setState({
      isCalculationModal: !this.state.isCalculationModal
    })
  }

  onYearProjectionChange = (value) => {
    this.setState({isYearChanging: false, selectedCard: 0})
    this.props.onSetYearProjection({topYearProjection: value})
    setTimeout(() => localStorage.setItem("LUCI_DATAS", JSON.stringify(this.props.state)), 100)
    /*setTimeout(() => {
      this.setState({isYearChanging: false})
    }, 500)*/
  }

  onIncludeIntroChange = () => {
    this.setState({selectedCard: 0})
    this.props.onSetYearProjection({topIncludedIntroBonus: !this.props.topIncludedIntroBonus})
    setTimeout(() => localStorage.setItem("LUCI_DATAS", JSON.stringify(this.props.state)), 100)
  }

  render() {
    const { selectedDate, selectedCard, selectedCardInfo, selectedRange, isRunTested, selectedFeatures, selectedCategories, isSettingModal, isCalculationModal, isYearChanging, isCardDetailsModal } = this.state
    const {
      isManualCost,
      cardList,
      statics,
      fetchCardsFailure,
      fetchCardsLoading,
      isAccountsLoading,
      getEnableCardsIds,
      fetchAccountsFailure,
      errorMessage,
      onFindCardModalChange,
      backToFirstStep,
      avgSpending,
      spending,
      isFindingCards,
      topYearProjection,
      topIncludedIntroBonus,
      onAccountsLoading,
      getAccountService,
    } = this.props;

    let object = {}
    if (isRunTested) {
      object.visible = false
    }
    
    const filteredCards = this.getCardsList() || [];

    const loading = isAccountsLoading || fetchCardsLoading || isFindingCards
    const loadingFailed = fetchCardsFailure || fetchAccountsFailure

    return (
      <div id="content" className="content-with-sidebar">

        {
          loading ?
            <div className="text-center mt-100"><Loading isInteral={true} isCenter={true}/></div> :
            <div className="card luci-card second-step">
              <div className="card-body" style={{padding: "16px 5px"}}>
              
                {/* title */}
                <h1 className="luci-title">
                  luci researched <span className="link-text">{loading ? <Spin className="mr-5px" /> : cardList.length} credit cards</span> and found a card with <span
                    className="link-text">${loading ? <Spin className="mr-5px" /> : commaSeparator(this.getTotalRewards())}</span> of reward
                </h1>
                
                {/* sub title */}
                {
                  isManualCost ?
                    <>
                      <div>
                        This result is based on your monthly spending estimates projected for a year (modify your estimates 
                        <a href="#" className="ml-1" onClick={onFindCardModalChange}>here</a>).
                      </div>
                      <div>
                        <a href="#" onClick={backToFirstStep}>Add accounts</a> to get a personalized recommendation using your actual spending data.
                      </div>
                    </>
                    :
                    <>
                      <div>
                        Based on your {this.onGetSelectedDate()} { selectedDate === 6 ? "" : "of" } spending data for {this.getSelectedCard()}
                      </div>
                      <div>
                        <b className="color-link cursor-pointer" onClick={this.onModalChange}>Change Settings</b>
                      </div>
                    </>
                }

                {/* error */}
                {
                  loadingFailed ?
                    <div className="mt-60 text-center w-100">
                      <h3>{ errorMessage || "Oops, Something went wrong. Please try again later." }</h3>
                    </div> : null
                }
                
                {/* divider */}
                <Divider style={{marginTop: 20, marginBottom:15}}/>

                {/* top spending */}
                {!loadingFailed?
                  <TopSpending
                    transactions_statistics={statics}
                    avgSpending={avgSpending}
                    isManualCost={isManualCost}
                    spending={spending}
                    selectedDate={selectedDate}
                    getSelectedDate={this.getSelectedDate}
                    onAccountsLoading={onAccountsLoading}
                    getAccountService={getAccountService}
                    backToFirstStep={backToFirstStep}
                  /> : null
                }

              </div>

              {/* divider */}
              <Divider style={{marginTop: 15, marginBottom: 5}}/>

              {/*   */}
              {!loadingFailed && !loading ?
                <div className="card-body padd-xs">
                  
                  <div className="pick-text mb-0 text-left" style={{paddingLeft: "5px", paddingRight: "5px"}}>
                    <h3><b>Recommended cards based on your spending</b></h3>
                  </div>

                  <div style={{paddingLeft: "5px", paddingRight: "5px"}}>
                    Browse your personalized recommendations from luci ranked by total rewards.
                  </div>

                  {/* dropdown filter settings (new) */}
                  <div className="view-top-cards mt-2">
                    <FilterSettings {...{
                      selectedCategories,
                      selectedFeatures,
                      onDismissFilter: this.onDismissFilter,
                      onFilterChange: this.onFilterChange,
                      isIncludeIntroBonus: topIncludedIntroBonus,
                      onIncludeIntroChange: this.onIncludeIntroChange,
                      yearProjection: topYearProjection,
                      onYearProjectionChange: this.onYearProjectionChange,
                    }}/>
                  </div>

                  {isYearChanging ?
                      <div className="text-center mt-50 mb-50"><Skeleton avatar paragraph={{ rows: 8 }}  active className="card-skeleton"/></div> :
                      <>
                        {
                          filteredCards.length ?
                            (this.getCardsList().slice(0, 3) || []).map((card, index) => {
                                return (
                                    <CardInfoPanel {...{ 
                                        key: index,
                                        card, 
                                        index, 
                                        onGetDate: this.getSelectedDate,
                                        avgSpending: avgSpending,
                                        spending: spending,
                                        selectedDate: selectedDate,
                                        topYearProjection: topYearProjection,
                                        topIncludedIntroBonus: topIncludedIntroBonus,
                                        sectionNumber: 1,
                                    }}/>
                                );
                            })
                            :
                            <div className="text-center no-cards">
                              No Cards found!
                            </div>
                        }
                      </>
                  }

                  {/* divider */}
                  <Divider style={{marginTop: 20, marginBottom: 40}}/>

                  <RecommendedCards {...{
                    onSelectCard: this.onSelectCard, 
                    backToFirstStep: backToFirstStep,
                    yearProjection: topYearProjection,
                    isIncludeIntroBonus: topIncludedIntroBonus,
                  }}/>
                  
                  <MediaQuery minWidth={767}>
                    <AllCardsView
                      cardList={cardList}
                      onSelectCard={this.onSelectCard}
                      allCardsYearProjection={topYearProjection}
                    />
                  </MediaQuery>
                  
                </div>
                : null
              }

            </div>
        }

        {
          isSettingModal ?
            <SettingModal
              selectedDate={selectedDate}
              selectedRange={selectedRange}
              isAccountsLoading={isAccountsLoading}
              onCancel={this.onModalChange}
              onApplyingSetting={this.onApplyingSetting}
              onDateChange={this.onDateChange}
              onRangeDatesChange={this.onRangeDatesChange}
              getEnableCardsIds={getEnableCardsIds}
            /> : null
        }

        {
          isCalculationModal ?
            <RewardCalculationModal
              onClose={this.onCalculationModalChange}
              onCardChange={this.onCardChange}
            /> : null
        }

        {
          isCardDetailsModal ?
            <CardDetailsModal
              selectedCardInfo={selectedCardInfo || {}}
              onCancel={this.onSelectCard}
            /> : null
        }

      </div>
    )
  }
}

const mapStateToProps = state => ({
  state: state,
  isManualCost: state.costs.isManualCost || false,
  banks: state.accounts.banks || [],
  cardList: getCardsListByYearWise(cloneDeep(state.resultSetting.topIncludedIntroBonus ? state.cards?.cardsDetails?.results : state.cards?.cardsDetails?.noBonus_results), state.cards?.cardsDetails?.cards || {}, state.resultSetting.topYearProjection) || [],
  statics: state.cards.cardsDetails.transactions_statistics || [],
  avgSpending: state.cards.cardsDetails.avgSpending || "",
  spending: state.cards.cardsDetails.spending || "",
  fetchCardsLoaded: state.cards.fetchCardsLoaded || false,
  fetchCardsLoading: state.cards.fetchCardsLoading || false,
  fetchCardsFailure: state.cards.fetchCardsFailure || false,
  errorMessage: state.cards.errorMessage || false,
  fetchAccountsFailure: state.accounts.fetchAccountsFailure || false,
  topYearProjection: state.resultSetting.topYearProjection,
  topIncludedIntroBonus: state.resultSetting.topIncludedIntroBonus
});

const mapDispatchToProps = dispatch => {
  return {
    onSetCards: data => {
      dispatch(setCards(data));
    },
    onFetchCards: data => {
      dispatch(fetchCards(data));
    },
    onSetYearProjection: (data) => {
      dispatch(setResultSetting(data))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondStep);
